module.exports = flarum.core.compat['components/IndexPage'];